exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host /deep/ .ng-input input {\n  padding: 0;\n}\n\n:host /deep/ .ng-select {\n  width: 220px;\n}\n\n:host /deep/ .ng-dropdown-panel {\n  left: 0;\n}\n:host /deep/ .ng-select-container {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-align: center !important;\n      align-items: center !important;\n}\n:host /deep/ .ng-input {\n  top: 0 !important;\n}\n:host /deep/ .ng-option {\n  width: 100%;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /data/jenkins_data/workspace/NaturallyPlus_WEB_UAT/src/app/enroll-record-list/enroll-record-list.component.css
// module id = ../../../../../src/app/enroll-record-list/enroll-record-list.component.css
// module chunks = main